/** Shared helpers for MM/DD/YY celebration fields (wizard + giftee profile). */

import { Timestamp } from "firebase/firestore";

export function formatShortCelebrationDateInput(value) {
  const digits = value.replace(/\D/g, "").slice(0, 6);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

export function isValidCalendarMMDDYY(s) {
  const m = /^(\d{2})\/(\d{2})\/(\d{2})$/.exec(s);
  if (!m) return false;
  const month = Number(m[1]);
  const day = Number(m[2]);
  const year = 2000 + Number(m[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return false;
  const d = new Date(year, month - 1, day);
  return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day;
}

export function expandShortDateToMMDDYYYY(s) {
  const [month, day, year] = s.split("/");
  return `${month}/${day}/20${year}`;
}

/** Next occurrence date for repeating yearly reminders — matches AddGifteeWizard. */
export function getNextAnnualDate(dateText) {
  const [monthText, dayText] = dateText.split("/");
  const now = new Date();
  const date = new Date(now.getFullYear(), Number(monthText) - 1, Number(dayText));
  if (date < now) date.setFullYear(now.getFullYear() + 1);
  return date;
}

/** `{ month, day, yearCentury }` from Fire reminder timestamp for MM/DD/YY input. */
export function timestampToMmDdYy(ts) {
  if (!ts) return "";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  if (Number.isNaN(d.getTime())) return "";
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  return `${mm}/${dd}/${yy}`;
}

/** `date` + `repeat` for `users/.../reminders` — mirrors AddGifteeWizard reminder creation. */
export function reminderTimestampAndRepeat(mmddYy, annual) {
  const expanded = expandShortDateToMMDDYYYY(mmddYy);
  let reminderDate;
  if (annual) {
    reminderDate = getNextAnnualDate(expanded);
  } else {
    const parts = expanded.split("/");
    const month = parseInt(parts[0], 10) - 1;
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    reminderDate = new Date(year, month, day);
  }
  return {
    timestamp: Timestamp.fromDate(reminderDate),
    repeat: annual ? "yearly" : "once",
  };
}
